import {
  CartUpdateEvent,
  GorgiasChatProgrammaticOpenEvent,
  KlaviyoFormProgrammaticOpenEvent,
} from "@theme/events";
import {
  isClickedOutside,
  onDocumentReady,
  onGorgiasReady,
} from "@theme/utilities";

onDocumentReady(() => {
  // This will sync local theme cart counts with changes made within the Rebuy SmartCart flyout drawer
  document.addEventListener("rebuy:cart.change", (event) => {
    if (event?.detail?.cart?.cart) {
      const cart = event.detail.cart.cart;

      document.dispatchEvent(
        new CartUpdateEvent(cart, "rebuy", {
          source: "rebuy:cart.change",
          itemCount: cart.item_count,
        }),
      );
    }
  });

  const openGorgiasChatEventHandler = (event) => {
    const { page, prefillMessage } = event?.detail || {};

    // @see https://docs.gorgias.com/en-US/subscribe-to-chat-events-460530 for adding more Gorgias events
    onGorgiasReady().then(() => {
      if (page) {
        window.GorgiasChat.setPage(page);
      }

      if (prefillMessage) {
        window.GorgiasChat.setCurrentInput(prefillMessage);
      }

      window.GorgiasChat.open();
    });
  };

  const openKlaviyoFormEventHandler = (event) => {
    const { formId } = event?.detail?.data || event?.detail || {};

    if (formId) {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(["openForm", formId]);
    }
  };

  // Add a global custom event listener for the programmatic opening of the Gorgias chat widget.
  document.addEventListener(
    GorgiasChatProgrammaticOpenEvent.eventName,
    openGorgiasChatEventHandler,
  );

  // Add a global custom event listener for the programmatic opening of a Klaviyo form.
  document.addEventListener(
    KlaviyoFormProgrammaticOpenEvent.eventName,
    openKlaviyoFormEventHandler,
  );

  // Setup an event listener when the Gorgias chat widget is ready and open to allow closing
  // the open Gorgias chat widget if the user clicks outside the chat window's GUI
  onGorgiasReady().then(() => {
    /**
     * Handles clicks outside of the Gorgias chat widget container.
     *
     * When the chat widget is open and the user clicks outside of its container,
     * this function closes the widget. It relies on the helper function
     * `isClickedOutside` to determine whether the click occurred outside
     * of the chat container element.
     *
     * @param {MouseEvent} event - The click event triggered by the document.
     */
    const outsideClickHandler = (event) => {
      const widgetContainer = document.getElementById("gorgias-chat-container");

      if (
        window.GorgiasChat?.isOpen() &&
        widgetContainer &&
        isClickedOutside(event, widgetContainer)
      ) {
        window?.GorgiasChat.close();
      }
    };

    // Handle closing an open Gorgias chat widget if the user clicks outside the chat's GUI
    window.GorgiasChat?.on("widget:opened", () => {
      // Use `requestIdleCallback` to add listener on next event loop. This avoid conflicts with programmatic widget open() calls.
      requestIdleCallback(() => {
        // We can use the `once` option because the widget body is an iframe and won't register a click unless clicked outside
        document.addEventListener("click", outsideClickHandler, { once: true });
      });
    });
  });
});
